let prefix = '/api/sap/supplier-invoices-report';

function mapRelation(docEntry){
    return window.axios.get(prefix+'/map-relation/'+docEntry);
}

export default {
    mapRelation,
}